import React, { FC, useState } from "react";
import {
  DPPageWrapper,
  DPButton,
  DPCheckbox,
  DPChip,
  DPSearchBar,
  DPPercentagePill,
  DPTable,
} from "Components/DP";
import { Typography, Box, TableRow, TableCell } from "@material-ui/core";
import useStyles from "./styles";
import ColorPalette from "./ColorPalette/ColorPalette";

const StyleGuide: FC = () => {
  const [state, setState] = useState({
    foo: false,
    bar: false,
  });

  function handleCheck(evt: { target: HTMLInputElement }) {
    const { value, checked } = evt.target;
    setState({ ...state, [value]: checked });
  }

  const classes = useStyles();

  return (
    <DPPageWrapper title="Style Guide">
      <Typography variant="h3">Color Palette</Typography>
      <ColorPalette />

      <Box className={classes.box}>
        <Typography variant="h3">Typography</Typography>
        <Typography variant="h1">Header One</Typography>
        <Typography variant="h2">Header Two</Typography>
        <Typography variant="h3">Header Three</Typography>
        <Typography variant="h4">Header Four</Typography>
        <Typography variant="h5">Header Five</Typography>
        <Typography variant="body1">
          Body 1. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
          do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
          ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </Typography>
        <Typography variant="body2">
          Body 2. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
          do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
          ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </Typography>
      </Box>
      <Box className={classes.box}>
        <Typography variant="h3">Search</Typography>
        <DPSearchBar disabled={false} submitSearch={(_: string) => {}} />
      </Box>
      <Box className={classes.box}>
        <Typography variant="h3">Buttons</Typography>
        <DPButton align="left">Default</DPButton>
        <DPButton align="left" color="primary">
          Primary
        </DPButton>
        <DPButton align="left" disabled={true}>
          Disabled
        </DPButton>
      </Box>

      <Box className={classes.box}>
        <Typography variant="h3">Checkboxes</Typography>
        <DPCheckbox
          value="foo"
          checked={state.foo}
          label="foo"
          disabled={false}
          onChange={handleCheck}
        />
        <DPCheckbox
          value="bar"
          checked={state.bar}
          label="bar"
          disabled={true}
          onChange={handleCheck}
        />
      </Box>
      <Box className={classes.box}>
        <Typography variant="h3">Chips</Typography>
        <DPChip label="Default" color="default" />
        <DPChip label="Primary" color="primary" />
        <DPChip label="Secondary" color="secondary" />
        <DPChip label="Error" color="error" />
        <DPChip label="Warn" color="warn" />
      </Box>
      <Box className={classes.box}>
        <Typography variant="h3">Percentage Pills</Typography>
        <Typography align="center" variant="h4">
          Broad Use
        </Typography>
        <DPPercentagePill
          netEarningsAmountCents={1000}
          totalTransferredEarlyAmountCents={600}
          totalFeeAmountCents={500}
          remainderAmountCents={350}
          negativeBalancePaidSettlementAmountCents={0}
        />
        <Typography align="center" variant="h4">
          Total Use
        </Typography>
        <DPPercentagePill
          netEarningsAmountCents={1000}
          totalTransferredEarlyAmountCents={900}
          totalFeeAmountCents={100}
          remainderAmountCents={0}
          negativeBalancePaidSettlementAmountCents={0}
        />
        <Typography align="center" variant="h4">
          No Use
        </Typography>
        <DPPercentagePill
          netEarningsAmountCents={1000}
          totalTransferredEarlyAmountCents={0}
          totalFeeAmountCents={0}
          remainderAmountCents={1000}
          negativeBalancePaidSettlementAmountCents={0}
        />
      </Box>
      <Box className={classes.box}>
        <Typography variant="h3">Tables</Typography>
        <DPTable
          headers={[
            "foo",
            "bar",
            "left",
            { label: "center", align: "center" },
            { label: "right", align: "right" },
          ]}
          count={5}
          page={0}
          rowsPerPage={10}
          onChangePage={() => {}}
        >
          {[1, 2, 3, 4, 5].map(idx => (
            <TableRow key={idx}>
              <TableCell>foo</TableCell>
              <TableCell>bar</TableCell>
              <TableCell>left</TableCell>
              <TableCell align="center">center</TableCell>
              <TableCell align="right">right</TableCell>
            </TableRow>
          ))}
        </DPTable>
      </Box>
    </DPPageWrapper>
  );
};

export default StyleGuide;
